import { Component, viewChild } from '@angular/core';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { CustomerComponent } from '../../../shared/account/profile/customer/customer.component';
import { HeaderComponent } from '../../customer/common/header/header.component';
import { FooterComponent } from '../../public/common/footer/footer.component';
import { ToastComponent } from '../../../common/toast/toast.component';
import { ModalsComponent } from '../../../common/modals/modals.component';
import { ModalsService } from 'src/app/services/Modals/modals.service';
import { ToastService } from 'src/app/services/Toast/toast.service';
import {
  SidebarComponent,
  SidebarLink,
} from '../../../common/internal-sidebar/internal-sidebar.component';
import { HeaderComponent as InternalHeaderComponent } from '../../../common/templates/header/header.component';
import { FooterComponent as InternalFooterComponent } from '../../../common/templates/footer/footer.component';
import { InternalComponent } from '../../../shared/account/profile/internal/internal.component';

@Component({
  selector: 'user-profile',
  imports: [
    CustomerComponent,
    HeaderComponent,
    FooterComponent,
    ToastComponent,
    ModalsComponent,
    SidebarComponent,
    InternalHeaderComponent,
    InternalFooterComponent,
    InternalComponent,
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class ProfileComponent {
  toastComponent = viewChild.required<ToastComponent>('toast');
  modalsComponent = viewChild.required<ModalsComponent>('modals');
  navLinks!: SidebarLink[];
  role!: { title: string; name: string };

  constructor(
    private auth: AuthService,
    private modal: ModalsService,
    private toast: ToastService
  ) {
    this.role = {
      name: this.auth.getCurrentRole()!,
      title: this.auth.getCurrentRoleTitle()!,
    };
  }

  ngOnInit() {
    this.toast.bindComponent(this.toastComponent());
    this.modal.bindComponent(this.modalsComponent());
    this.initSidebar();
  }
  initSidebar() {
    this.navLinks = this.getSidebarRole();
  }

  getSidebarRole(): SidebarLink[] {
    switch (this.role.name) {
      case 'system_admin':
        return [
          {
            name: 'Dashboard',
            icon: 'bi-house',
            url: '/sysad/dashboard',
          },
          {
            name: 'Users',
            icon: 'bi-people',
            url: '/sysad/users',
          },
          {
            name: 'Archive',
            icon: 'bi-archive',
            url: '/sysad/users/archive',
          },

          // {
          //   name: 'Settings',
          //   icon: 'bi-gear',
          //   url: '/sysad/settings',
          // },
        ];
      case 'fae':
        return [
          {
            name: 'Dashboard',
            icon: 'bi-house',
            url: '/fae',
          },
          {
            name: 'Quotation',
            icon: 'bi-tags',
            url: '/fae/quotation',
          },
          {
            name: 'Clients',
            icon: 'bi-people',
            url: '/fae/clients',
          },
          {
            name: 'Products',
            icon: 'bi-box',
            url: '/fae/products',
          },
        ];
      case 'tsm':
        return [
          {
            name: 'Dashboard',
            icon: 'bi-house',
            url: '/tsm',
          },
          {
            name: 'Products',
            icon: 'bi-box',
            url: '/tsm/products',
          },
          {
            name: 'Quotation',
            icon: 'bi-tags',
            url: '/tsm/quotation',
          },
          {
            name: 'Academe',
            icon: 'bi-mortarboard',
            url: '',
            children: [
              {
                name: 'Academe Tags',
                icon: 'bi-mortarboard',
                url: '/tsm/academe',
              },
              {
                name: 'Academe Brands',
                icon: 'bi-mortarboard',
                url: '/tsm/academe/brands',
              },
            ],
          },
        ];
      case 'approver':
        return [
          {
            name: 'Dashboard',
            icon: 'bi-house',
            url: '/approver',
          },
          {
            name: 'Quotation',
            icon: 'bi-tags',
            url: '/approver/quotation',
          },
          {
            name: 'Products',
            icon: 'bi-box',
            url: '/approver/products',
          },
        ];

      case 'product_admin':
        return [
          {
            name: 'Dashboard',
            icon: 'bi-house',
            url: '/product-admin',
          },
          {
            name: 'Quotation',
            icon: 'bi-tags',
            url: '/product-admin/quotation',
          },
          {
            name: 'Clients',
            icon: 'bi-people',
            url: '/product-admin/clients',
          },
          {
            name: 'Products',
            icon: 'bi-box',
            url: '/product-admin/products',
          },
          {
            name: 'Academe',
            icon: 'bi-mortarboard',
            url: '',
            children: [
              {
                name: 'Academe Tags',
                icon: 'bi-mortarboard',
                url: '/product-admin/academe/tags',
              },
              {
                name: 'Academe Brands',
                icon: 'bi-mortarboard',
                url: '/product-admin/academe/brands',
              },
            ],
          },
          {
            name: 'Industrial',
            icon: 'bi-wrench-adjustable-circle',
            url: '',
            children: [
              {
                name: 'Industrial Tags',
                icon: 'bi-wrench-adjustable-circle',
                url: '/product-admin/industrial/tags',
              },
              {
                name: 'Industrial Brands',
                icon: 'bi-wrench-adjustable-circle',
                url: '/product-admin/industrial/brands',
              },
            ],
          },
        ];
      case 'ts':
        return [
          {
            name: 'Dashboard',
            icon: 'bi-house',
            url: '/ts',
          },
          {
            name: 'Products',
            icon: 'bi-box',
            url: '/ts/products',
          },
          {
            name: 'Industrial',
            icon: 'bi-wrench-adjustable-circle',
            url: '',
            children: [
              {
                name: 'Industrial Tags',
                icon: 'bi-wrench-adjustable-circle',
                url: '/ts/industrial/tags',
              },
              {
                name: 'Industrial Brands',
                icon: 'bi-wrench-adjustable-circle',
                url: '/ts/industrial/brands',
              },
            ],
          },
        ];
      default:
        return [];
    }
  }
}
